import type { SearchScenarioId } from "owa-search-store";
import { action } from "satcheljs";

export interface SetInKeyboardSelectionMode {
    scenarioId: SearchScenarioId;
    inKeyboardSelectionMode: boolean;
}

export const setInKeyboardSelectionMode: (scenarioId: SearchScenarioId, inKeyboardSelectionMode: boolean) => SetInKeyboardSelectionMode = action("setInKeyboardSelectionMode", function setShowSearchBoxInCompactMode(scenarioId: SearchScenarioId, inKeyboardSelectionMode: boolean): SetInKeyboardSelectionMode {
    return {
        scenarioId,
        inKeyboardSelectionMode,
    };
});
